import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Box, ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 3,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [2.8, 0.1, 2.0], mass: 1, position: [0, -1, 0], type: 'Box' },
      { args: [2.8, 0.1, 1.9], mass: 1, position: [0, -0.3, 0.3], rotation: [Math.PI / 4, 0, 0], type: 'Box' },
      { args: [2.0, 0.1, 0.2], mass: 1, position: [0, -0.875, 1], rotation: [-Math.PI / 4, 0, 0], type: 'Box' },
    ], 
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box position={[0, -1  ,   0  ]} args={[2.8, 0.1, 2.0]} />
      <Box position={[0, -0.3,   0.3]} args={[2.8, 0.1, 1.9]} rotation={[Math.PI / 4, 0, 0]} />
      <Box position={[0, -0.875, 1  ]} args={[2.0, 0.1, 0.2]} rotation={[-Math.PI / 4, 0, 0]} color="#2a2a2a" />
    </group>
  );
};
